import { useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './index.module.scss';

interface UserAccountMenuProps {
  isOpen: boolean;
  onClose: () => void;
  onMyAccountClick: () => void;
  onLogoutClick: () => void;
}

export default function UserAccountMenu({
  isOpen,
  onClose,
  onMyAccountClick,
  onLogoutClick,
}: UserAccountMenuProps) {
  const { t } = useTranslation();

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape' && isOpen) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('keydown', handleKeyDown);
    }

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [isOpen, onClose]);

  const handleMyAccountClick = useCallback(() => {
    onMyAccountClick();
    onClose();
  }, [onMyAccountClick, onClose]);

  const handleLogoutClick = useCallback(() => {
    onLogoutClick();
    onClose();
  }, [onLogoutClick, onClose]);

  if (!isOpen) {
    return null;
  }

  return (
    <div className={styles.dropdown}>
      <div className={styles.arrow} />
      <button
        type="button"
        className={styles.dropdownItem}
        onClick={handleMyAccountClick}
        data-testid="my-account-button"
      >
        {t('informa.ping-identity.ribbon.user-section.my-account')}
      </button>
      <button
        type="button"
        className={styles.dropdownItem}
        onClick={handleLogoutClick}
        data-testid="logout-button"
      >
        {t('informa.ping-identity.ribbon.user-section.logout')}
      </button>
    </div>
  );
}
